import { render } from "./LoadingSpan.vue?vue&type=template&id=0ab74634&scoped=true"
import script from "./LoadingSpan.vue?vue&type=script&lang=js"
export * from "./LoadingSpan.vue?vue&type=script&lang=js"

import "./LoadingSpan.vue?vue&type=style&index=0&id=0ab74634&scoped=true&lang=css"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab74634"]])

export default __exports__